/**
 * Created by Ning Jiang on 2/7/2019.
 */
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {DebugInfo} from "../background/DebugInfo";
import {TeslaBackground} from "../background/TeslaBackground";
import {BackgroundWindow} from "./components/animations/BackgroundWindow";
import {TeslaWildCollectIndicatorView} from "./freespin/collectIndicator/TeslaWildCollectIndicatorView";
import {TeslaFreespinWinPresentation} from "./freespin/TeslaFreespinWinPresentation";
import {TeslaWildCollectReleaseAnimation} from "./freespin/TeslaWildCollectReleaseAnimation";
import {TeslaFreeSpinOutroAnimation} from "./freespin/transitions/TeslaFreeSpinOutroAnimation";
import {TeslaFreeSpinScreenAnimation} from "./freespin/transitions/TeslaFreeSpinScreenAnimation";
import {TeslaIntroView} from "./intro/TeslaIntroView";
import {TeslaReelController} from "./reel/TeslaReelController";
import {TeslaReelPartCreator} from "./reel/TeslaReelPartCreator";
import {TeslaReelView} from "./reel/TeslaReelView";
import {TeslaReelAreaView} from "./reelarea/TeslaReelAreaView";
import {TeslaReelFrameView} from "./reelarea/TeslaReelFrameView";
import {TeslaNearWinReelDivider} from "./reeldivider/TeslaNearWinReelDivider";
import {BonusSymbolFreespin} from "./reelstoppresentation/bonussymbolfreespin/BonusSymbolFreespin";
import {BonusSymbolFreespinView} from "./reelstoppresentation/bonussymbolfreespin/BonusSymbolFreespinView";
import {TeslaBonusSymbolView} from "./reelstoppresentation/bonussymbolmain/TeslaBonusSymbolView";
import {TeslaMainGameBonusController} from "./reelstoppresentation/bonussymbolmain/TeslaMainGameBonusController";
import {TeslaScatterAttentionController} from "./reelstoppresentation/scatterattention/TeslaScatterAttentionController";
import {TeslaWildAttentionController} from "./reelstoppresentation/wildattention/TeslaWildAttentionController";
import {TeslaFreeSpinIntroController} from "./screen/TeslaFreeSpinIntroController";
import {TeslaFreeSpinIntroScreenView} from "./screen/TeslaFreeSpinIntroScreenView";
import {TeslaFreeSpinOutroController} from "./screen/TeslaFreeSpinOutroController";
import {TeslaFreeSpinOutroScreenView} from "./screen/TeslaFreeSpinOutroScreenView";
import {TeslaParsedGameData} from "./server/data/TeslaParsedGameData";
import {TeslaParsedInitData} from "./server/data/TeslaParsedInitData";
import {TeslaServerDataParser} from "./server/TeslaServerDataParser";
import {TeslaSpinController} from "./spin/TeslaSpinController";
import {Tesla} from "./Tesla";
import {TeslaFontConfig} from "./TeslaFontConfig";
import {TeslaGameAssets} from "./TeslaGameAssets";
import {TeslaGameConfig} from "./TeslaGameConfig";
import {TeslaSoundConfig} from "./TeslaSoundConfig";
import {TeslaSoundPlayer} from "./TeslaSoundPlayer";
import {TeslaBigWinController} from "./winpresentation/bigwin/TeslaBigWinController";
import {TeslaInitialWPController} from "./winpresentation/initial/TeslaInitialWPController";
import {TeslaBetLineWinPresentationView} from "./winpresentation/initial/views/TeslaBetLineWinPresentationView";
import {TeslaBetLineWinIndividualWPController} from "./winpresentation/TeslaBetLineWinIndividualWPController";


export class TeslaGameModuleConfig implements IGameModuleConfig {

    public static instance:TeslaGameModuleConfig = new TeslaGameModuleConfig();

    GAME_CONFIG:IGameConfig = TeslaGameConfig.instance;
    FONTS_CONFIG:IFontsConfig = TeslaFontConfig.getConfig();
    SOUND_CONFIG:ISoundConfig = TeslaSoundConfig.instance;
    RESOURCES_CONFIG:IResourcesGroupConfig = TeslaGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new TeslaServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data:any, dataParser:ServerDataParser) => new TeslaParsedInitData(data, <TeslaServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data:any, dataParser:ServerDataParser) => new TeslaParsedGameData(data, <TeslaServerDataParser>dataParser);

    REEL_CONTROLLER?:(reelId:number) => ReelController = (reelId:number) => new TeslaReelController(reelId);
    REEL_VIEW:(reelId:number) => PIXI.Container = (reelId:number) => new TeslaReelView(reelId);
    REEL_PART_CREATOR?:() => ReelPartCreator = () => new TeslaReelPartCreator();

    REEL_AREA_VIEW:() => ReelAreaView = () => new TeslaReelAreaView();

    INTRO_VIEW:(onClickCallback:() => void) => TeslaIntroView =
        (onClickCallback:() => void) => new TeslaIntroView({
            resourceGroup : ResourcesGroupName.INTRO,
            layer : GameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            mobileScale : 1.2,
            portraitScale : 1
        });

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new FreespinZeroBetController()
    ];

    SCREENS:(() => ScreenController)[] = [
        () => new TeslaFreeSpinIntroController({
            viewCreator : (onContinueButtonClickCallback:() => void) => new TeslaFreeSpinIntroScreenView(onContinueButtonClickCallback)
        }),
        () => new TeslaFreeSpinOutroController({
            viewCreator : (onContinueButtonClickCallback:() => void) => new TeslaFreeSpinOutroScreenView(onContinueButtonClickCallback)
        })
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new TeslaFreespinWinPresentation(indexes)],
        [
            indexes => { return new TeslaInitialWPController(indexes); }
        ],
        [indexes => new TeslaBigWinController(indexes)]
    ];


    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new TeslaBetLineWinIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0.0;
        }
    });

    SPIN_CONTROLLER?:() => SpinController = () => new TeslaSpinController();

    REEL_STOP_PRESENTATIONS?:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new TeslaMainGameBonusController(index),
        (index:number) => new BonusSymbolFreespin(index),
        (index:number) => new TeslaScatterAttentionController(index, {
            numOfScattersToWin : 3,
            attentionSoundName : TeslaSoundConfig.instance.SCATTER_ATTENTION,
            winAttentionSoundName : TeslaSoundConfig.instance.SCATTER_WIN

        }),
        (index:number) => new TeslaWildAttentionController(index),
    ];

    GAME_FEATURE_CREATOR:() => void = () => {
        Tesla.soundPlayer = new TeslaSoundPlayer();
        Tesla.background = new TeslaBackground();

        if(GameSetting.isDevMode) {
            const debugBackground = new DebugInfo(false);
        }

        Tesla.nearWinReelDivider = new TeslaNearWinReelDivider({
            layer : TeslaGameConfig.instance.LAYERS.REEL_ATTENTION.name,
            texturesGetter : (index:number) => {return null;},
            positions : [
                [68, -20],
                [198, -20],
                [328, -20],
                [458, -20],
                [588, -20]
            ],
            nearWinLayer : TeslaGameConfig.instance.LAYERS.REEL_ATTENTION.name,
            nearWinTexturesGetter : (index:number) => {
                let textures:PIXI.Texture[] = GameResources.getTextures(TeslaGameAssets.NEAR_WIN_ANIMATION);
                textures.unshift(PIXI.Texture.EMPTY);
                textures.push(PIXI.Texture.EMPTY);
                return textures;
            },
            reelIndexMap : [[], [], [2], [3], [4]],
            nearWinBlendMode : PIXI.BLEND_MODES.ADD,

        });

        Tesla.freespinScreenAnimation = new TeslaFreeSpinScreenAnimation();
        Tesla.freespinOutroAnimation = new TeslaFreeSpinOutroAnimation(ResourcesGroupName.MAIN);

        Tesla.reelFrame = new TeslaReelFrameView(ResourcesGroupName.MAIN);
        Tesla.betLineWinView = new TeslaBetLineWinPresentationView(ResourcesGroupName.MAIN);
        Tesla.wildCollectIndicator = new TeslaWildCollectIndicatorView(ResourcesGroupName.MAIN);
        Tesla.wildCollectRelease = new TeslaWildCollectReleaseAnimation(ResourcesGroupName.MAIN);
        Tesla.bonusSymbolView = new TeslaBonusSymbolView(ResourcesGroupName.MAIN);
        Tesla.bonusSymbolFreespinView = new BonusSymbolFreespinView(ResourcesGroupName.MAIN);

        Tesla.backgroundWindowAnimation = new BackgroundWindow(ResourcesGroupName.MAIN);

        StageManager.legacyScaling = true;
    };


    constructor() {
        if(TeslaGameModuleConfig.instance) {
            throw new Error("BlankSlotGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}